import * as Notifications from "expo-notifications";
import { Platform } from "react-native";

const RATING_REMINDER_DELAY_SECONDS = 24 * 60 * 60;

function reminderIdentifier(bookingId: number): string {
  return `rating-reminder-${bookingId}`;
}

async function ensureNotificationPermissions(): Promise<boolean> {
  const { status: existingStatus } = await Notifications.getPermissionsAsync();

  if (existingStatus === "granted") {
    return true;
  }

  const { status } = await Notifications.requestPermissionsAsync();

  return status === "granted";
}

export async function scheduleRatingReminder(bookingId: number): Promise<void> {
  if (Platform.OS === "web") {
    return;
  }

  try {
    const hasPermission = await ensureNotificationPermissions();

    if (!hasPermission) {
      return;
    }

    await Notifications.cancelScheduledNotificationAsync(
      reminderIdentifier(bookingId),
    );

    await Notifications.scheduleNotificationAsync({
      identifier: reminderIdentifier(bookingId),
      content: {
        title: "Rate Your Experience",
        body: "How was your experience? Please leave a rating.",
        data: {
          type: "request_rating",
          booking_id: bookingId,
        },
      },
      trigger: {
        type: Notifications.SchedulableTriggerInputTypes.TIME_INTERVAL,
        seconds: RATING_REMINDER_DELAY_SECONDS,
        repeats: false,
      },
    });
  } catch (error) {
    console.error("Failed to schedule rating reminder:", error);
  }
}

export async function cancelRatingReminder(bookingId: number): Promise<void> {
  if (Platform.OS === "web") {
    return;
  }

  try {
    await Notifications.cancelScheduledNotificationAsync(
      reminderIdentifier(bookingId),
    );
  } catch (error) {
    console.error("Failed to cancel rating reminder:", error);
  }
}
